export default "__VITE_ASSET__9$EZd$tv__"